/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ofType } from 'redux-observable';
import { combineLatest, of } from 'rxjs';
import { withLatestFrom, pluck, mergeMap } from 'rxjs/operators';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import { getExtensionAvailability } from '../../utils/availabilityGridUtil';
import {
    CLEAR_SELECTIONS,
    FETCH_AVAILABILITY_DATA_SUCCESS,
    PAUSE_LOADING,
    PROCESS_AVAILABILITY_COMPLETE,
} from '../../constants';

/**
 *
 * @param {Observable} action$ - a stream of actions
 * @param {Observable} state$ - a stream of redux store states
 */
export const processAvailabilityEpic = (action$, state$) =>
    action$.pipe(
        ofType(
            CLEAR_SELECTIONS, // when all existing selections are cleared
            FETCH_AVAILABILITY_DATA_SUCCESS // when new search campsites are fetched
        ),
        withLatestFrom(
            combineLatest(
                state$.pipe(pluck('availabilityGrid')),
                state$.pipe(pluck('campground'), pluck('campground'), pluck('results'))
            )
        ),
        mergeMap((stream) => {
            const states = stream[1];
            const [availabilityData, campground] = states;
            const { originalAvailabilitiesMap } = availabilityData;
            /* If we just fetched brand new availabilities (FETCH_AVAILABILITY_DATA_SUCCESS)
        or cleared all selections (CLEAR_SELECTIONS), need to reprocess availabilities for ALL campsites */
            const processedAvailabilities = cloneDeep(originalAvailabilitiesMap);

            if (isEmpty(originalAvailabilitiesMap)) {
                return of({
                    type: PAUSE_LOADING,
                });
            }

            forEach(originalAvailabilitiesMap, (data) => {
                const { availabilities, campsite_id: campsiteId } = data;
                if (!isEmpty(availabilities)) {
                    const extensionAvailabilities = getExtensionAvailability({
                        availabilities,
                        facilityType: campground.facility_type,
                    });

                    set(
                        processedAvailabilities,
                        `${campsiteId}.availabilities`,
                        extensionAvailabilities
                    );
                }
            });

            return of({
                type: PROCESS_AVAILABILITY_COMPLETE,
                payload: processedAvailabilities,
            });
        })
    );
